import { Component, Input, OnInit } from '@angular/core';
import { EmpAdditionalDocRequests, Employee, EmployeeProfile, EmployeeProfileApi, DocumentType } from '../../core/api.gen';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../core/toast.service';

@Component({
  selector: 'eos-emp-additional-doc-request',
  templateUrl: './emp-additional-doc-request.component.html',
  styles: []
})
export class EmpAdditionalDocRequestComponent implements OnInit {

  @Input() profile: EmployeeProfile;
  @Input() public submit: (requestList) => void;
  documentList: DocumentType[] ;
  distinctDocTypes: DocumentType[];
  fileDetails: any;
  AddedDocs: DocumentType[] = [];
  requestList= [];
  requestedDocs = [];
  isDocumentAdded = false;

  constructor(public modal: NgbActiveModal, public employeeApi: EmployeeProfileApi, private toast: ToastService) {
    this.clearSelect();
  }

  ngOnInit() {
    this.getDocumentTypes();
    this.getAlreadyRequestedlist();
  }
  requestDocuments() {
    this.modal.close();
    this.submit(this.requestList);

  }
  getCombainedId(doc) {
    return doc.docNameId + '~' + doc.docNameDisplayText;
  }
  addDocs(f) {
    if (f.invalid) {
      return;
    }
    this.isDocumentAdded = false;
    let doc = this.documentTypes.find(x => <string>(this.fileDetails.combainedId).endsWith(x.docNameDisplayText)
      && (this.fileDetails.combainedId).startsWith(x.docNameId));

    if (!(this.AddedDocs.filter(res => res.docNameDisplayText == doc.docNameDisplayText).length > 0)) {
      var res = this.documentList.find(t => t.docNameDisplayText === doc.docNameDisplayText);
      this.AddedDocs.push(res);
      this.fileDetails.docTypeDisplayText = res.docTypeDisplayText;
      this.fileDetails.docNameId = res.docNameId;
      this.fileDetails.docNameDisplayText = res.docNameDisplayText;
      this.requestList.push(this.fileDetails);
      this.isDocumentAdded = true;
      this.clearSelect();
    } else {
      this.toast.warning('Document already requested');
      return;
    }
  }
  clearSelect() {
    this.fileDetails = new EmpAdditionalDocRequests();
    this.fileDetails.docTypeId = null;
    this.fileDetails.docNameId = null;
    this.fileDetails.combainedId = null;
    this.fileDetails.docNameDisplayText = "";
    this.fileDetails.comment = "";
    this.fileDetails.isMandatory = true;
  }
  deleteDocs(item) {
    this.AddedDocs.forEach((value, index) => {
      if (value.docNameDisplayText === item.docNameDisplayText)
        this.AddedDocs.splice(index, 1);
    });
    this.requestList.forEach((value, index) => {
      if (value.docNameDisplayText === item.docNameDisplayText)
        this.requestList.splice(index, 1);
    });
  }

  getDocumentTypes() {
    this.documentList = [];
    this.employeeApi.getRequiredEmployeeDocuments(this.profile.id, false).subscribe(resp => {
     
      this.documentList = resp;
     
    });

  }

  get getdistinctDocTypes(): DocumentType[] {
    this.distinctDocTypes = [];
    if (this.documentList && this.documentList.length > 0) {
      this.distinctDocTypes = this.documentList.filter(
        (docType, i, arr) => arr.findIndex(t => t.docTypeId === docType.docTypeId) === i);
    }
    return this.distinctDocTypes;
  }

  setCMDocTypes() {
    this.fileDetails.combainedId = null;
    const filteredVals = this.documentList.filter(t => t.docTypeId === this.fileDetails.docTypeId);
    if (filteredVals.length === 1) {
      this.fileDetails.combainedId = filteredVals[0].docNameId + '~' + filteredVals[0].docNameDisplayText;
    }
  }

  get documentTypes() {
   
    if (!this.documentList.length) { return [] }
    return this.documentList.filter(doc => doc.docTypeId === +this.fileDetails.docTypeId);
   
  }
  getAlreadyRequestedlist() {
    this.employeeApi.getRequestedEmpDocuments(this.profile.id)
      .subscribe(resp => {
        this.requestedDocs = resp;
      });
  }
  replaceGPNwithCode(docName:string){ 
    let docN = docName && docName.indexOf("GPN_") > -1 ?
      docName.replace("GPN", "CC+GUI") : `${"CC+GUI"}_${docName}`
    return docN;
  }
}
